import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { lastValueFrom } from 'rxjs';
import { FastAPIService } from 'src/app/service/fast-api.service';

interface SuggestionItem {
  count: number;
  Link_OD: string;
}


@Component({
  selector: 'app-suggestion',
  templateUrl: './suggestion.component.html',
  styleUrls: ['./suggestion.component.scss']
})
export class SuggestionComponent implements OnInit {
  suggestNews: any[] = [];
  loading: boolean = true;

  constructor(private route: ActivatedRoute, private router: Router, private fastService: FastAPIService) { }

  async ngOnInit(): Promise<void> {
    const SuggestionResponse = await lastValueFrom(this.fastService.getHistoryTrending(8));
    const SuggestionRecords: SuggestionItem[] = SuggestionResponse.data;
    let SuggestionLink_OD: string[] = []
    SuggestionRecords.forEach((item: SuggestionItem) => {
      SuggestionLink_OD.push(item.Link_OD);
    });
    const NewsResponse = await lastValueFrom(this.fastService.getNewsByIDs(SuggestionLink_OD))
    const data = NewsResponse.data.response.docs;
    this.suggestNews = [];
    for (let index of data) {
      if (index.ScrapingType == 'File') {
        index.icon = "assets/search-component-images/fi_file-text.svg"
      }
      else {
        if (index.ScrapingType == "Social-Media") {
          index.icon = index.Picture_URL_OD[0]
        }
        else {
          index.icon = await this.fastService.getFavicon(index.Link_OD);
        }
      }
      this.suggestNews.push(index);
    }
    this.loading = false;
  }

  onNewsClick(news: any) {
    if (news.ScrapingType === 'Social-Media') {
      this.router.navigate(['/social-media', { id: encodeURIComponent(news.Link_OD) }]);
    } else {
      this.router.navigate(['/news', { id: encodeURIComponent(news.Link_OD) }]);
    }
  }

  onImageError(event: Event) {
    const target = event.target as HTMLImageElement;
    target.src = this.fastService.getDefaultImage();
  }
}
